import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';

import Link from '../Link/Link';

const ResendCodeLink = ({ onClick, duration = 60 }: { onClick: () => void; duration?: number }) => {
  const { t } = useTranslation('account');
  const intervalRef = useRef<number | undefined>(undefined);
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    intervalRef.current = window.setInterval(() => {
      setTimeLeft((current) => {
        if (current === 1) clearInterval(intervalRef.current);
        return current - 1;
      });
    }, 1000);
  }, []);

  if (timeLeft > 0) {
    return <p>{t('challenge.reset_password.send_code_in_second', { seconds: timeLeft })}</p>;
  }

  return (
    <p>
      <Link
        onClick={() => {
          onClick();
          setTimeLeft(duration);
        }}
      >
        {t('challenge.reset_password.send_code')}
      </Link>
    </p>
  );
};

export default ResendCodeLink;
